import { render, staticRenderFns } from "./modal-wrap.vue?vue&type=template&id=81a14bf2&"
import script from "./modal-wrap.vue?vue&type=script&lang=js&"
export * from "./modal-wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modal: require('/var/www/components/modal/modal.vue').default})
